module.exports = __webpack_public_path__ + "img/user.8af7bbea.svg";